<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <div id="flowChart" :style="echartStyle"></div>
        <Drawer title="检索条件" v-model="showSearchDrawer" width="360" 
            :styles="styles"  :inner="true" :transfer="false">
            <Form ref="formSearch" :model="formSearch" :rules="ruleSearch">
                <FormItem label="时间" label-position="top">
                    <DatePicker :transfer="true" v-model="formSearch.echartDate" type="date" split-panels
                        placeholder="不筛选时间..." style="width:326px;" :clearable="false"></DatePicker>
                </FormItem>
                <FormItem label="时间类型" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateType">
                        <Option value="YEAR">年</Option>
                        <Option value="QUARTER">季度</Option>
                        <Option value="MONTH">月</Option>
                        <Option value="DAY">日</Option>
                    </Select>
                </FormItem>
                <FormItem label="间隔周期" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateCircle">
                        <Option v-for="item in [1,2,3,5,7,10]" :value="item" :key="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="时间跨域" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateLength">
                        <Option v-for="item in [1,2,3,4,5,6,7,8,9,10]" :value="item" :key="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="地址" label-position="top">
                    <Cascader :transfer="true" v-model="formSearch.echartArea" :data="addressData" change-on-select
                        filterable :render-format="formatAddress" transfer @on-change="choiceAddress" :clearable="false"></Cascader>
                </FormItem>
                <div style="width: 100%; position: absolute; bottom: 0; left: 0; border-top: 1px solid #e8e8e8;
                            padding: 10px 16px; text-align: right; background: #fff;">
                    <Button type="primary" long @click="onCommit">设置</Button>
                </div>
            </Form>
        </Drawer>
    </div>
</template>

<script>
    export default {
        name: "eCharts_flow",
        data(){
            return{
                showSearchDrawer: false,
                styles: {
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },
                addressData: [],
                addressRange: '',
                height: document.body.clientHeight,
                width: document.body.clientWidth,
                isSpinShow: false,
                receiveData: [],
                formSearch: {
                    echartDate: global.dateFtt("yyyy-MM-dd hh:mm:ss",
                        new Date(new Date().getTime() - 3600 * 1000 * 24 * 5)),
                    echartDateType: "DAY",
                    echartDateCircle: 1,
                    echartDateLength: 5,
                    echartArea: []
                },
                ruleSearch: {
                    
                },
                option:{
                    baseOption: {
                        timeline: {
                            axisType: 'category',
                            autoPlay: true,
                            playInterval: 3000,
                            data: [],
                            label: {
                            }
                        },
                        title: {
                            subtext: '用气量统计'
                        },
                        tooltip: {
                        },
                        legend: {
                            x: 'right',
                            data: []
                        },
                        calculable: true,
                        grid: {
                            left: '5%',
                            right: '5%',
                            top: 80,
                            bottom: 100,
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow',
                                    label: {
                                        show: true,
                                        formatter: function(params) {
                                            return params.value.replace('\n', '');
                                        }
                                    }
                                }
                            }
                        },
                        yAxis: [{
                            'type': 'category',
                            'axisLabel': {
                                'interval': 0,
                                'inside': false,
                                'rotate': -30
                            },
                            triggerEvent : true,
                            data: [],
                            splitLine: {
                                show: false
                            }
                        }],
                        xAxis: [{
                            type: 'value',
                            name: 'm³'
                        }],
                        series: []
                    },
                    options: []
                }
            }
        },
        computed: {
            echartStyle() {
                var style = {};
                style.width = this.width * 0.8 + 'px';
                style.height = this.height * 0.8 + 'px';
                return style;
            }
        },
        mounted(){
            $("div.ivu-drawer-body").addClass("scrollbar");
            let that = this;
            that.isSpinShow = true;
            //获得地址
            $.ajax({
                url: "/api/getAddressTree",
                contentType: "application/json",
                async: false,
                type: "get",
                dataType: "json",
                success: function(data) {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }
                    that.addressData = data.body[0].children;
                    that.addressRange = data.body[0].children[0].name;
                    that.formSearch.echartArea.push(data.body[0].children[0].id);
                    that.getData();
                },
                error: function(textStatus) {
                    that.$Notice.error({
                        title: "异常",
                        desc: "接口请求异常"
                    });
                }
            });
        },
        methods:{
            //获取数据函数
            getData(){
                let that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/instructions/getCountFlow",
                    contentType: "application/json",
                    type: "post",
                    data:JSON.stringify(
                        that.formSearch
                    ),
                    dataType: "json",
                    success: function(data) {
                        if(data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.receiveData = data.body;
                        that.load();
                        that.isSpinShow = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            //加载视图函数
            load(){
                let that = this;
                that.showData();
                let echarts = that.$echarts.init(document.getElementById("flowChart"));
                echarts.setOption(that.option, true);
                echarts.on('click', function (params) {
                    if(params.componentType == "yAxis"){
                        that.showSearchDrawer = true;
                    }else{
                    }
                });
            },
            //展示数据格式化函数
            showData(){
                let that = this;
                that.showTimeline();
                that.option.baseOption.yAxis[0].data = [];
                that.option.baseOption.series = [];
                that.option.baseOption.legend.data = [];
                that.option.options = [];
                that.receiveData.map((timeParam,indexF)=>{
                    let param = {};
                    //添加timeline标题
                    if (timeParam.length > 0) {
                        param['title'] = {};
                        param['title']['text'] = that.option.baseOption.timeline.data[indexF] + '用气量';
                        param['series'] = [];
                    }
                    [{'name':'工况流量','value':'flow'},{'name':'标况流量',
                        'value':'flowStandard'}].map((itemBar,indexS) => {
                        //添加bar坐标和legend
                        if (indexF == 0){
                            let seriesParam = {};
                            seriesParam['name'] = itemBar.name;
                            seriesParam['type'] = 'bar';
                            //seriesParam['stack'] = '总量';
                            that.option.baseOption.series.push(seriesParam);
                            that.option.baseOption.legend.data.push(itemBar.name);
                        }
                        
                        let dateCell = [];
                        timeParam.map((item,indexT) => {
                            //添加横坐标
                            if (indexF == 0 && indexS == 0) {
                                let itemParam = item["addressName" + (that.formSearch.echartArea.length + 1)];
                                that.option.baseOption.yAxis[0].data.push(itemParam);
                            }
                            dateCell[indexT] = {};
                            dateCell[indexT]['name'] = itemBar.name;
                            dateCell[indexT]['value'] = item[itemBar.value] / 1000;
                        });
                        var tempParam = {};
                        tempParam['data'] = dateCell;
                        param.series.push(tempParam);
                    })
                    
                    that.option.options.push(param);
                });
            },
            //处理时间轴
            showTimeline(){
                let that = this;
                that.option.baseOption.timeline.data = [];
                let dateFormat = "yy-MM-dd hh:mm:ss";
                switch (that.formSearch.echartDateType) {
                    case "YEAR":
                        dateFormat = "yy-MM";
                        break;
                    case "QUARTER":
                        dateFormat = "yy-MM";
                        break;
                    case "WEEK":
                        dateFormat = "MM-dd";
                        break;
                    case "DAY":
                        dateFormat = "MM-dd";
                        break;
                    default:
                        dateFormat = "yy-MM-dd";
                        break;
                }
                for (let i = 0; i < that.formSearch.echartDateLength; i++) {
                    that.option.baseOption.timeline.data.push(
                        global.dateFtt(dateFormat, new Date(that.formSearch.echartDate)
                            .dateAdd(that.formSearch.echartDateType, i * that.formSearch.echartDateCircle))
                    );
                }
            },
            formatAddress(labels, selectedData) {
                this.addressRange = labels.join('');
                return labels.join(' / ');
            },
            choiceAddress(param){
                this.formSearch.echartArea = param;
            },
            onCommit(){
                this.showSearchDrawer = false;
                this.getData();
            }
        }
    }
    Date.prototype.dateAdd = function(interval, number) {
        var d = this;
        var k = {
            'YEAR': 'FullYear',
            'QUARTER': 'Month',
            'MONTH': 'Month',
            'WEEK': 'Date',
            'DAY': 'Date',
            'HOUR': 'Hours',
            'MINUTE': 'Minutes',
            'SECOND': 'Seconds',
            'ms': 'MilliSeconds'
        };
        var n = {
            'QUARTER': 3,
            'WEEK': 7
        };
        eval('d.set' + k[interval] + '(d.get' + k[interval] + '()+' + ((n[interval] || 1) * number) + ')');
        return d;
    }
</script>

<style>
    /*自定义滚动条*/ 
    .scrollbar { 
      overflow-y: auto; 
    } 
    .scrollbar::-webkit-scrollbar { 
      width: 0px; 
    } 
</style>